import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ProjectSectionS4 = ({ projects, projectsIsloading, projectsError }) => {
    const settings = {
        dots: false,
        arrows: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const { t } = useTranslation();
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div className="wpo-project-area black-bg">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="wpo-project-wrap project-active owl-carousel">
                        {projectsIsloading ? <p>{t("loading")}...</p> : projectsError ? <p>{t("error")}</p> : (
                            <Slider {...settings}>
                                {projects.slice(0, 6).map((project, index) => (
                                    <div className="wpo-project-item" key={index}>
                                        <div className="wpo-project-img">
                                            <img src={`${process.env.REACT_APP_API_URL}/api/images/${project?.data?.thumbnail}`} alt={project?.data?.title} />
                                            <div className="left-border"></div>
                                            <div className="right-border"></div>
                                        </div>
                                        <div className="wpo-project-text">
                                            <h2>
                                                <Link onClick={ClickHandler} to={`/project-single/${project.slug}`}>
                                                    {project?.data?.title}
                                                </Link>
                                            </h2>
                                            <span>{project?.data?.description?.slice(0, 80)}...</span>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectSectionS4;
